import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';

@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.css']
})
export class MobileMenuComponent extends BaseClass<any> implements OnInit {

  public isLoading: boolean = false;
  public user: any;

  constructor(public service: WebserviceService,
    public router: Router,
    private _message: MessageService,
    private _common: CommonService) { super(); }

  ngOnInit(): void {
    this.user = (localStorage.getItem(`${this.env.panel}user`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}user`) as any) : '';
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  logOut() {
    this.getServices().Get(`${this.env.baseUrl + this.api.logout}`).subscribe(
      (res) => {

        this._common.removeLocalstorage();
        // this.router.navigate(['/login']);
        this.router.navigate(['/home']);
        this._message.succmessage(res.message);
        window.location.reload();
      },
      (err) => {
        console.log(err);
      });
  }

  toogleBody() {
    const bodyElement = document.body;
    if (bodyElement) {
      if (this.env.darkMode) {
        bodyElement.classList.add('dark-body');
      } else if (!this.env.darkMode) {
        bodyElement.classList.remove('dark-body');
      }
    }
    this.setLocalItem('darkMode', this.env.darkMode)
  }

}
